export enum BypassableValues {
  Zero = 0,
}

/**
 * Determines if a given value is considered "truthy".
 *
 * A value is considered truthy if it is not:
 * - `null`
 * - `undefined`
 * - `0` (unless `bypass` is `BypassableValues.Zero`)
 * - an empty string `""`
 * - `false`
 *
 * @param value - The value to check for truthiness.
 * @param bypass - An optional parameter to bypass certain falsy checks.
 * @returns A boolean indicating if the value is truthy.
 */

export function isTruthy(
  value: unknown,
  bypass?: BypassableValues,
): value is boolean | number | object | string {
  return (
    value !== null &&
    value !== undefined &&
    (value !== 0 || bypass === BypassableValues.Zero) &&
    value !== "" &&
    value !== false
  );
}
